import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds, WireTransferCategory } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UploadReceiptEvidenceArg {
    engagementId: number;
    category: WireTransferCategory;
    sourceRowId: number | null;
    file: File;
}

export const UploadReceiptEvidence = createAsyncThunk(
    'flowOfFunds/uploadReceiptEvidence',
    async (arg: UploadReceiptEvidenceArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const formData = new FormData();
        formData.append('file', arg.file);

        try {
            const response = await axios.post(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/Evidence/Receipt`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    params: {
                        category: arg.category,
                        sourceRowId: arg.sourceRowId,
                    },
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to upload the receipt evidence document');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while uploading the evidence document.',
                'error'
            );
            throw error;
        }
    }
);
